'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('HubStyleTokens/colors');

var _ComponentWithUniqueIds = require('../mixins/ComponentWithUniqueIds');

var _ComponentWithUniqueIds2 = _interopRequireDefault(_ComponentWithUniqueIds);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _memoize = require('react-utils/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _Functions = require('../core/Functions');

var _UIButton = require('../button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIIconCircle = require('../icon/UIIconCircle');

var _UIIconCircle2 = _interopRequireDefault(_UIIconCircle);

var _lazyEval = require('../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _createLazyPropType = require('../utils/propTypes/createLazyPropType');

var _createLazyPropType2 = _interopRequireDefault(_createLazyPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var FilePreviewLabel = _styledComponents2.default.label.withConfig({
  displayName: 'UIFileInput__FilePreviewLabel'
})(['margin-left:12px;']);

var getSuccessIcon = (0, _memoize2.default)(function () {
  return _react2.default.createElement(_UIIconCircle2.default, {
    backgroundColor: _colors.OZ_MEDIUM,
    color: _colors.OLAF,
    name: 'success',
    padding: 0.25,
    size: 9,
    verticalAlign: 'text-top'
  });
});

var UIFileInput = _react2.default.createClass({
  displayName: 'UIFileInput',

  mixins: [_ComponentWithUniqueIds2.default, _reactAddonsPureRenderMixin2.default],

  propTypes: {
    accept: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
    buttonClassName: _react.PropTypes.string,
    changeLabel: (0, _createLazyPropType2.default)(_react.PropTypes.node).isRequired,
    onChange: _react.PropTypes.func,
    onClick: _react.PropTypes.func,
    selectLabel: (0, _createLazyPropType2.default)(_react.PropTypes.node).isRequired,
    showFilePreview: _react.PropTypes.bool.isRequired,
    use: _UIButton2.default.propTypes.use,
    value: _react.PropTypes.oneOfType([_react.PropTypes.instanceOf(window.File), _react.PropTypes.shape({
      name: _react.PropTypes.string
    })])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      accept: [],
      changeLabel: function changeLabel() {
        return _I18n2.default.text('salesUI.UIFileInput.defaultChangeLabel');
      },
      selectLabel: function selectLabel() {
        return _I18n2.default.text('salesUI.UIFileInput.defaultSelectLabel');
      },
      showFilePreview: true,
      use: 'secondary'
    };
  },
  handleClick: function handleClick(evt) {
    var onClick = this.props.onClick;


    this._inputEl.click();
    (0, _Functions.callIfPossible)(onClick, evt);
  },
  handleFileSelect: function handleFileSelect(evt) {
    var onChange = this.props.onChange;

    (0, _Functions.callIfPossible)(onChange, (0, _SyntheticEvent2.default)(evt.target.files[0], evt));
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        accept = _props.accept,
        buttonClassName = _props.buttonClassName,
        changeLabel = _props.changeLabel,
        className = _props.className,
        __onChange = _props.onChange,
        __onClick = _props.onClick,
        selectLabel = _props.selectLabel,
        showFilePreview = _props.showFilePreview,
        use = _props.use,
        value = _props.value,
        rest = _objectWithoutProperties(_props, ['accept', 'buttonClassName', 'changeLabel', 'className', 'onChange', 'onClick', 'selectLabel', 'showFilePreview', 'use', 'value']);

    var computedId = this.getUniqueId('file');

    return _react2.default.createElement(
      'span',
      { className: (0, _classNames2.default)('private-file-button', className) },
      _react2.default.createElement(
        _UIButton2.default,
        {
          className: buttonClassName,
          onClick: this.handleClick,
          use: use
        },
        (0, _lazyEval2.default)(value ? changeLabel : selectLabel)
      ),
      showFilePreview && value && _react2.default.createElement(
        FilePreviewLabel,
        { htmlFor: computedId },
        getSuccessIcon(),
        ' ',
        value.name
      ),
      _react2.default.createElement('input', _extends({}, rest, {
        accept: accept.join(','),
        className: 'hidden',
        id: computedId,
        onChange: this.handleFileSelect,
        ref: function ref(_ref) {
          return _this._inputEl = _ref;
        },
        type: 'file'
      }))
    );
  }
});

exports.default = (0, _Controllable2.default)(UIFileInput);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/input/UIFileInput.js
// module id = 551
// module chunks = 171